import { Component, OnInit, AfterViewChecked, ViewChild } from '@angular/core';
import { RightSideDrawerService } from '../right-side-drawer.service';
import { SessionService } from '../../session-service/session.service';
import { DefineActivitiesService } from '../../../data-analysis-summary/define-activities/define-activities.service';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  AbstractControl,
} from '@angular/forms';
import { Activity } from '../../models/ep-activity.model';
import { ToastrService } from '@kpmg-tax/ui';
import { API_URL } from '../../constants/apiurl-constants';
import { BaseResponse } from '../../models/base-response.model';
import { Messages } from '../../constants/messages';
import { encodeText } from 'src/app/shared/lib/custom-tools';
import { ActivityTypeEnum } from 'src/app/shared/constants/activity-type.enum';
import { Observable, of, debounceTime, distinctUntilChanged, switchMap, combineLatest, combineLatestWith, tap, Subject } from 'rxjs';
import { ACTIVITYSUBTYPES, ACTIVITY_CONSTANTS, ACTIVITY_SUBTYPE_CONSTANTS, APP_CONSTANTS } from '../../constants/app-constants';
import { MasterActivitiesService } from 'src/app/admin/master-activities/master.activities.service';
import { MasterActivities } from '../../models/master-activity/master-activities.model';
import { CustomDropDown } from '../../models/custom-dropdown.model';
import { CustomDropdownComponent } from '../../custom-dropdown/custom-dropdown.component';
import { WhiteSpaceValidator } from 'src/app/core/validators/whitespace-validator';

@Component({
  selector: 'ep-edit-activity',
  templateUrl: './ep-edit-activity.component.html',
  styleUrls: ['../ep-add-activity/ep-add-activity.component.scss'],
})
export class EpEditActivityComponent implements OnInit, AfterViewChecked {
  // specific form group name in template file
  targetForm: FormGroup;
  _EngagementActivity: any;
  _singlerow: any;
  isDisabled: boolean = true;
  engagementId: number;
  activityGroupList: MasterActivities[] = [];
  activityGroupObserver: Subject<string> = new Subject<string>();
  dropdownOptions: CustomDropDown[] = [];
  showActivitySubTypeValidation: boolean;
  selectedActivitySubType:string = '';
  selectedActivitySubTypeId:number;
  @ViewChild(CustomDropdownComponent) private customDropdownComponent!: CustomDropdownComponent;
  isActivitySubTypeSelected:boolean = false;
  disableActivitySubtype:boolean = false;
  isActivityGroupSelected: boolean = false;

  constructor(private _masterActivitiesService: MasterActivitiesService,
    public rightSideDrawerService: RightSideDrawerService,
    public activitiesService: DefineActivitiesService,
    public _toasterService: ToastrService,
    public sessionService: SessionService,
    public formBuilder: FormBuilder,
  ) { this.dropdownOptions = this.getActivtiySubTypeOptions();}

  // reset form content
  public resetRightSideDrawerData = () => {
    let qpPerc = +this.rightSideDrawerService.singleRowEditData.qPercentage
      .toString()
      .replace('%', '');
    this.targetForm = new FormGroup({

      activityGroup: new FormControl(this.rightSideDrawerService.singleRowEditData.activityGroup, [Validators.required,WhiteSpaceValidator.cannotContainSpace]),
      name: new FormControl(
        this.rightSideDrawerService.singleRowEditData.name,
        [
          Validators.required,
          Validators.maxLength(100),WhiteSpaceValidator.cannotContainSpace,
          this.UniqueActivityNameUpdate(
            this._EngagementActivity,
            this.rightSideDrawerService.singleRowEditData,
          ),
        ],
      ),

      description: new FormControl(
        this.rightSideDrawerService.singleRowEditData.desc,
        [Validators.maxLength(500)],
      ),
      percentage: new FormControl(qpPerc, [
        Validators.required,
        Validators.min(0),
        Validators.max(100),
        Validators.pattern('^[0-9]+(.[0-9]{1,2})?$'),
      ]),
    });
    if (this.rightSideDrawerService.singleRowEditData.isMaster === 'Yes' && 
        (this.rightSideDrawerService.singleRowEditData.activityType === ActivityTypeEnum.Activity &&
          this.rightSideDrawerService.singleRowEditData.subTypeName !== ACTIVITY_SUBTYPE_CONSTANTS.NQ41Q174
        ))
    {
      this.targetForm.get('name').disable();
      this.targetForm.get('activityGroup').disable();
      this.targetForm.get('description').disable();
      this.disableActivitySubtype = true;
    }
    else if (this.rightSideDrawerService.singleRowEditData.isMaster === 'Yes' && 
      (this.rightSideDrawerService.singleRowEditData.activityType === ActivityTypeEnum.NQA|| 
      this.rightSideDrawerService.singleRowEditData.activityType === ActivityTypeEnum.NWT ||
      (this.rightSideDrawerService.singleRowEditData.activityType === ActivityTypeEnum.Activity  &&
      this.rightSideDrawerService.singleRowEditData.subTypeName === ACTIVITY_SUBTYPE_CONSTANTS.NQ41Q174)
      ))
    {
      this.targetForm.get('activityGroup').disable();
      this.targetForm.get('percentage').disable();
      this.disableActivitySubtype = true;
    }
    else if (this.rightSideDrawerService.singleRowEditData.isMaster === 'No' && 
      (this.rightSideDrawerService.singleRowEditData.activityType !== ActivityTypeEnum.Activity  || 
        this.rightSideDrawerService.singleRowEditData.subTypeName === ACTIVITY_SUBTYPE_CONSTANTS.NQ41Q174
      )) 
    {
      this.targetForm.get('activityGroup').disable();
      this.targetForm.get('percentage').disable();
      this.disableActivitySubtype = true;
    }
    this.selectedActivitySubTypeId = this.rightSideDrawerService.singleRowEditData.activityType;
    this.selectedActivitySubType = this.rightSideDrawerService.singleRowEditData.subTypeName; 
    this.isActivitySubTypeSelected = this.selectedActivitySubType?.length > 0;
  }
  get f() {
    return this.targetForm?.controls;
  }

  trimSpecialChar(ctrl: any) {
    this.targetForm.controls[ctrl].setValue(
      this.targetForm.get(ctrl).value.replace(/[^a-zA-Z0-9-()._#!$%^+=&,*@/ ]/g, ''),
    );
  }

  UniqueActivityNameUpdate(activityList: any, row: any) {
    return (control: AbstractControl): { [key: string]: any } => {
      const actName = this.trim(control.value).toUpperCase();
      if (
        row.name.toUpperCase() !== actName &&
        activityList.find(x => x.name.toUpperCase() === actName)
      ) {
        return { UniqueAName: true };
      }
      return null;
    };
  }

  trim(x) {
    return x ? x.replace(/^\s+|\s+$/gm, '') : '';
  }

  ngOnInit() {
    this.engagementId = parseInt(this.sessionService.getSession('engagementId'));
    this._EngagementActivity = this.rightSideDrawerService.multipleRowAddData;
    this._singlerow = this.rightSideDrawerService.singleRowEditData;
    this.resetRightSideDrawerData();
    this.getAllActivities(this.engagementId);
  }

  getAllActivities(engagementId: number): void {
    this.activityGroupList = [];
    let masterActivities$ = this._masterActivitiesService.GetActivityGroup() as Observable<any>;
    let engagementActivities$ = this.activitiesService.GetEngagementActivities(engagementId);
    combineLatest([masterActivities$, engagementActivities$]).pipe(tap(([masterActivities, engagementActivities]) => {
      this.activityGroupList = masterActivities?.result;
      engagementActivities?.result.forEach(item => {
        if (item.activityGroup?.trim().length > 0 && this.activityGroupList.findIndex(x => x.activityGroup.toLowerCase() === item.activityGroup?.toLowerCase()) < 0) {
          this.activityGroupList.push({ activityGroup: item.activityGroup, activityID: item.activityID, name: item.name, activityType: item.activityType, qPercentage: item.qPercentage });
        }
      });
    })).subscribe();
  }

  searchActivityGroup(term: any): Observable<any> {
    if (this.activityGroupList) {
      return of(this.activityGroupList.filter((item: any) =>
        item.activityGroup.toLowerCase().includes(term.toLowerCase()) && item.activityGroup.toLowerCase() != ACTIVITY_CONSTANTS.NQA.toLowerCase() && item.activityGroup.toLowerCase() != ACTIVITY_CONSTANTS.NWT.toLowerCase()),
      );
    } else {
      return of([]);
    }
  }

  activityGroupFormatter = (result: any) =>
    typeof result.activityGroup === 'undefined' ? result : result.activityGroup;

  filterActivityGroup = (searchPhrase$: Observable<any>) =>
    searchPhrase$.pipe(debounceTime(150), distinctUntilChanged(), switchMap(term => {
      return this.searchActivityGroup(term).pipe(switchMap(data => {
        return of(data);
      }));
    }))

  activityGroupValidationDelayer(activityGroup: string) {
    if (this.activityGroupObserver.observers.length === 0) {
      this.activityGroupObserver.pipe(debounceTime(200)).subscribe(() => {
        this.activityGroupValidation();
      });
    }
    this.activityGroupObserver.next(activityGroup);
  }

  activityGroupValidation() {
    let activityGroupInput = this.targetForm.get('activityGroup').value;
    let activityGrounName;
    if (activityGroupInput.activityGroup === undefined) {
      activityGrounName = activityGroupInput;
    } else {
      activityGrounName = activityGroupInput.activityGroup;
    }

    if (activityGrounName.toUpperCase() == 'NQA') {
      this.targetForm.patchValue({ activityGroup: 'NQA', percentage: 0 });
    } else {
      for (let activity of this.activityGroupList) {
        if (activityGrounName.toLowerCase() == activity.activityGroup.toLowerCase()) {
          this.targetForm.patchValue({ activityGroup: activity.activityGroup });
          break;
        }
      }
    }

    if (activityGrounName.toLowerCase() == APP_CONSTANTS.NWT.toLowerCase()) {
      this.targetForm.patchValue({ activityGroup: APP_CONSTANTS.NWT, percentage: 0 });
    }
    this.isDisabled = false;
  }

  ngAfterViewChecked() {
    // Refresh form inputs if drawer is opened or loaded.
    if (this.rightSideDrawerService.triggerRightSideDrawerClick) {
      this.rightSideDrawerService.triggerRightSideDrawerClick = false; // Set trigger to false so that this action is only performed once. Without this, the form would keep resetting on every change on any input.
      this.resetRightSideDrawerData();
    }
  }

  editActivity = () => {
    let eid = this.sessionService.getSession('engagementId');

    let activity: any = {
      activityID: this.rightSideDrawerService.singleRowEditData.activityID,
      name: encodeText(this.targetForm.get('name').value),
      desc: encodeText(this.targetForm.get('description').value),
      qPercentage: this.targetForm.get('percentage').value,
      activityGroup: this.getActivityGroupFormValue(),
      engagementId: eid,
      activityType: this.selectedActivitySubTypeId,
      subTypeName: this.selectedActivitySubType
    };

    if (activity.activityID === 0) {
      this.rightSideDrawerService.closeRightSideDrawer();
      return;
    }
    activity = this.sessionService.removeNullEmptyValues(activity);
    this.sessionService.apiUrlPost(API_URL.UPDATEENGAGEMENTACTIVITY, activity).subscribe((data: BaseResponse) => {
      if (data !== null && data.success) {
        let tabledata: Array<Activity> = this.activitiesService.tableDataFiltered;
        let row: Activity = tabledata.find(x => x.name === this.rightSideDrawerService.singleRowEditData.name);
        row.name = this.targetForm.get('name').value;
        row.qPercentage = this.targetForm.get('percentage').value + '%';
        row.desc = this.targetForm.get('description').value;
        this.activitiesService.tableDataFiltered = [...tabledata];
        this._toasterService.setSuccessMessage(Messages.Activity.UpdateActivitySuccess);
        this.activitiesService.refreshTable();
        this.rightSideDrawerService.closeRightSideDrawer();
      } else if (data !== null && !data.success && data.errorMessage === 'ASSIGNED') {
        this._toasterService.setErrorMessage(Messages.Activity.ActivityAssignedToSurvey);
      }
    });
  }

  private getActivityGroupFormValue(): string {
    var rawFormValue = this.targetForm.get('activityGroup').value;
    if (rawFormValue == null || rawFormValue == undefined)
      return "";
    if (rawFormValue.activityGroup == null || rawFormValue.activityGroup == undefined)
      return rawFormValue.trim();
    return rawFormValue.activityGroup.trim();
  }

  onEditActivityData() {
    let activity: any = {
      name: this.targetForm.get('name').value?.trim(),
      activityGroup: this.targetForm.get('activityGroup').value?.trim(),
      description: this.targetForm.get('description').value?.trim(),
      percentage: this.targetForm.get('percentage').value + '%',
      subTypeName: this.selectedActivitySubType
    };

    if (
      activity.name !== this._singlerow.name ||
      activity.activityGroup !== this._singlerow.activityGroup ||
      activity.description !== this._singlerow.desc ||
      activity.percentage !== this._singlerow.qPercentage ||
      activity.subTypeName !== this.rightSideDrawerService.singleRowEditData.subTypeName
    ) {
      this.isDisabled = false;
      this.rightSideDrawerService.setMandatoryField(true, 'Edit Activity');
    } else {
      this.isDisabled = true;
      this.rightSideDrawerService.setMandatoryField(false, '');
    }
  }

  public buildFrom(activity, activity1) {
    this.rightSideDrawerService.multipleRowAddData = activity;
    this.rightSideDrawerService.singleRowEditData = activity1;
  }

  private getActivtiySubTypeOptions(): CustomDropDown[] {
    const activitySubTypeOptions = ACTIVITYSUBTYPES;
    const options: CustomDropDown[] = [{ id: 0, value: '', isDisabled: false }];
    activitySubTypeOptions.forEach((item, index) => {
      options.push({ id: item.activitySubType, value: item.activitySubTypeName, isDisabled: false });
    });
    return options;
  }

  onActivitySubTypeSelected(optionSelected: CustomDropDown): void {
    if (optionSelected === null) {
      this.showActivitySubTypeValidation = this.selectedActivitySubType === '' ? true : false;
      this.customDropdownComponent.showError = this.selectedActivitySubType === '' ? true : false;
    } else {
      this.showActivitySubTypeValidation = false;
      this.customDropdownComponent.showError = false;
      this.selectedActivitySubType = optionSelected.value;
      this.selectedActivitySubTypeId = optionSelected.id;
      if(optionSelected.id > 0 || optionSelected.value === ACTIVITY_SUBTYPE_CONSTANTS.NQ41Q174){
        this.targetForm.patchValue({activityGroup: optionSelected.value, percentage: 0 });
        this.targetForm.controls['activityGroup'].disable();
        this.targetForm.controls['percentage'].disable();
      }else{    
        this.targetForm.patchValue({ activityGroup: '', percentage: 100 });    
        this.targetForm.controls['activityGroup'].enable();
        this.targetForm.controls['percentage'].enable();
      }
      this.isDisabled = false;
    }
    this.isActivitySubTypeSelected = !this.showActivitySubTypeValidation;
  }

  isBtnDisabled() {
    if (!this.targetForm.valid) {
      return true;
    }
    else if (!this.isActivitySubTypeSelected) {
      return true;
    } else if (this.isDisabled) {
      return true;
    }else {
      return false;
    }
  }
}
